import { isPropertyAccessOrQualifiedName } from 'typescript';
import {Address} from '../../models/Address';
import * as moment from 'moment';

export class UserLight {
  firstName: string;
  lastName: string;
  id: number;
  userName: string;
  address: Address;
  password: string;
  sendNewPass: boolean;
  selected: boolean;
  email: string;
  craId: number;
  clientId: number;
  mobilePhone: string;
  officePhone: string;
  fax: string;
  title: string;
  clientName: string;
  prettyCreatedDate: string;
  lockoutEnabled: boolean;
  lockoutEnd?: moment.Moment;
  isUserLockedOut: boolean;
  locationIds: number[];
  locations: string[];
  admin: boolean;
  viewBilling: boolean;
  viewReporting: boolean;
  addProperties: boolean;
  addUsers: boolean;
  startScreenings: boolean;
  decisionOnlyReport: boolean;
  canUnmaskPII: boolean;
  setPropertyDecision : boolean;
  isProcessor: boolean;
  createdDate: Date;
  userInvitationId: number;
  userAccountCreated: boolean;
  trackingToken: string;
  inviteToken: string;
  invitedDate: moment.Moment;
}

export class UserListContainer {
  public listResult: UserLight[];
  public totalRecordsCount: number;
}


export class UserSetting {
  id: number;
  settingName: string;
  settingsJSON: string;
  userId: number;
}

export class UserAudit {
  userName: string;
  Id: number;
  firstName : string;
  lastName : string;
}